
<div class="board-checkbox">
  <div class="form-check form-check-inline">
    <input :id="id" class="form-check-input" type="checkbox" :checked="value" @input="valueUpdated" :disabled="disabled" />
    <label :for="id" v-bind:class="labelStyle" class="form-check-label">{{ label }}</label>
  </div>
</div>
